import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Input } from '@angular/core';

// Avviso del prezzo sotto il minimo: la riga andrà in approvazione. Senza minimo (0 o assente) non compare
@Component({
  providers: [provideTranslocoScope('products')],
  imports: [TranslocoPipe],
  selector: 'prd-price-below-minimum-warning',
  template: `
    @if (visible) {
      <div class="price-warning">
        <i class="fa-solid fa-triangle-exclamation price-warning-icon"></i>
        <span class="body-medium">{{ 'products.ui.attenzionePrezzoInseritoSottoIlMinimoPrevistoERichiestaApprovazione' | transloco }}</span>
      </div>
    }
  `,
  styleUrl: './price-below-minimum-warning.scss',
})
export class PriceBelowMinimumWarning {
  @Input() price: number | null | undefined;
  @Input() minimum: number | null | undefined;

  get visible(): boolean {
    const minimum = this.minimum ?? 0;
    return this.price != null && minimum > 0 && this.price < minimum;
  }
}
